/***
*
*   USER
*   shows the current user 
*   if user belongs to more than one account they can switch accounts here
*
**********/

import React, { useContext } from 'react';
import { AuthContext, Link } from 'components/lib';
import LogoImage from '../logo/images/logo.svg';
import Profile from '../logo/images/profile.svg';
import Style from './user.module.scss';

export function User(props){

  const authContext = useContext(AuthContext);

  return (
    <Link url='/dashboard' className={ Style.user }>
      <img width={45} height={45} src={ props.mark ? Profile : LogoImage } alt={ props.mark ? 'Profile' : 'Deal Finder' } />
      <div className={ Style.name }>{ authContext?.user?.name }</div>
   </Link>
  )
}

